"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionCreators = {
    requestFunction: function (assembly, classname) { return function (dispatch, getState) {
        var appState = getState();
        var errorMessage = '';
        var isShowAlert = false;
        if (appState && appState.function && assembly !== appState.function.assembly) {
            fetch("/v1/get-function?assembly=" + assembly + "&classname=" + classname, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('FOCUSONE_API_GATEWAY'),
                },
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                console.log(data);
                if (data.message) {
                    isShowAlert = true;
                    console.log(data.message);
                    try {
                        var obj = JSON.parse(data.message);
                        errorMessage = obj.message;
                    }
                    catch (err) {
                        errorMessage = data.message;
                    }
                }
                else {
                    if (data && data != undefined && data.function_list != undefined) {
                        data.function_list.sort(function (a, b) {
                            var x = a.function_name.toLowerCase();
                            var y = b.function_name.toLowerCase();
                            if (x == y) {
                                return 0;
                            }
                            return x < y ? -1 : 1;
                        });
                    }
                }
                dispatch({ type: 'RECEIVE_FUNCTION', model: data, assembly: assembly, classname: classname, errorMessage: errorMessage, isShowAlert: isShowAlert });
            })
                .then(function (error) {
                console.log(error);
            });
            dispatch({ type: 'REQUEST_FUNCTION', assembly: assembly, classname: classname });
        }
    }; },
    clearAlert: function () { return function (dispatch, getState) {
        dispatch({ type: 'CLEAR_ALERT', errorMessage: '', isShowAlert: false });
    }; }
};
var unloadedState = { model: undefined, isLoading: false, assembly: "", classname: "", errorMessage: "", isShowAlert: false };
exports.reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_FUNCTION':
            return {
                model: state.model,
                isLoading: true,
                assembly: state.assembly,
                classname: state.classname,
                errorMessage: state.errorMessage,
                isShowAlert: state.isShowAlert
            };
        case 'RECEIVE_FUNCTION':
            return {
                model: action.model,
                isLoading: false,
                assembly: action.assembly,
                classname: action.classname,
                errorMessage: action.errorMessage,
                isShowAlert: action.isShowAlert
            };
        case 'CLEAR_ALERT':
            return {
                model: state.model,
                isLoading: false,
                assembly: state.assembly,
                classname: state.classname,
                errorMessage: action.errorMessage,
                isShowAlert: action.isShowAlert
            };
        default: return state;
    }
};
//# sourceMappingURL=Function.js.map